var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { FormField } from '../FormField';
import { FormGroup } from '../FormGroup';
import { FormButton, FormButtonToggle, FormCheckbox, FormColorPicker, FormDatePicker, FormDateRangePicker, FormDropdown, FormInput, FormRadio, FormSelect, FormTextArea, FormTogglebox, FormToggleSwitch, FormAnvilSelect, FormTimePicker, } from '../FormControls';
export const Form = (_a) => {
    var { action, children, className, el: Element = 'form', onSubmit, size = 'medium' } = _a, props = __rest(_a, ["action", "children", "className", "el", "onSubmit", "size"]);
    const handleSubmit = (e, ...args) => {
        // Third party libs can pass own data as first argument, we need to check that it has preventDefault() method.
        if (typeof action !== 'string') {
            e.preventDefault();
        }
        if (onSubmit) {
            onSubmit(e, Object.assign(Object.assign({}, props), args));
        }
    };
    const FormClasses = classnames('Form', className, `Form--${size}`);
    return (React.createElement(Element, Object.assign({}, props, { className: FormClasses, onSubmit: handleSubmit, "data-anvil-component": "Form" }), children));
};
Form.Checkbox = FormCheckbox;
Form.Radio = FormRadio;
Form.TextArea = FormTextArea;
Form.Button = FormButton;
Form.ButtonToggle = FormButtonToggle;
Form.ColorPicker = FormColorPicker;
Form.DatePicker = FormDatePicker;
Form.DateRangePicker = FormDateRangePicker;
Form.Dropdown = FormDropdown;
Form.Field = FormField;
Form.Group = FormGroup;
Form.Input = FormInput;
Form.Select = FormSelect;
Form.Togglebox = FormTogglebox;
Form.ToggleSwitch = FormToggleSwitch;
Form.AnvilSelect = FormAnvilSelect;
Form.TimePicker = FormTimePicker;
//# sourceMappingURL=Form.js.map